module.exports = __webpack_public_path__ + "static/media/e-citizen_Nigeria_Privacy_Notice_v2.1_Confirmed.9f6a8056.pdf";